import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70940a0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sequence" }
const _hoisted_2 = { class: "annotations" }
const _hoisted_3 = { class: "helps" }

import IconButton from "./IconButton.vue";
import Dialog from "./Dialog.vue";
import { computed, Ref, ref, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import { VDNA, toVDNAs } from "@/utils/v-dna";
import Tooltip from "./tooltip/Tooltip.vue";

type Annotation = { left: string; width: string; label: string };
type Line = { text: string; annotations: Annotation[] };

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const showDialog = ref(false);
const vDNAs = ref<VDNA[]>([]);
const { snakes, isRunning, beforePlaySnakes } = toRefs(useStore());
const open = () => {
  showDialog.value = true;
  const _snakes = isRunning ? snakes.value : beforePlaySnakes.value;
  vDNAs.value = toVDNAs(Object.values(_snakes));
};
const containerRef: Ref<HTMLElement | null> = ref(null);
const fontWidth = 9.6;
const lineLength = computed(() =>
  Math.floor(
    Math.max((containerRef.value?.clientWidth ?? 0) - 20, 0) / fontWidth
  )
);
const vDNASequences = computed(() => {
  let result: Line[] = [];
  const _lineLength = lineLength.value;
  if (_lineLength === 0) return result;
  for (const vDNA of vDNAs.value) {
    const lines: Line[] = [];
    let currentAnnotationIndex = 0;
    for (let i = 0; i < Math.ceil(vDNA.vDNA.length / _lineLength); i++) {
      const text = vDNA.vDNA.substring(i * _lineLength, (i + 1) * _lineLength);
      const annotations: Annotation[] = [];
      currentAnnotationIndex = Math.max(0, currentAnnotationIndex - 1);
      while (
        currentAnnotationIndex < vDNA.annotations.length &&
        vDNA.annotations[currentAnnotationIndex].from < (i + 1) * _lineLength
      ) {
        const currentAnnotation = vDNA.annotations[currentAnnotationIndex];
        if (currentAnnotation.to < i * _lineLength) {
          currentAnnotationIndex++;
          continue;
        }
        const left = Math.max(currentAnnotation.from - i * _lineLength, 0);
        const right = Math.min(
          currentAnnotation.to - i * _lineLength,
          _lineLength
        );
        annotations.push({
          left: `${left * fontWidth}px`,
          width: `${(right - left) * fontWidth}px`,
          label: currentAnnotation.label,
        });
        currentAnnotationIndex++;
      }
      lines.push({ text, annotations });
    }
    result = [...result, ...lines];
  }
  return result;
});

const help1Ref: Ref<HTMLElement | null> = ref(null);
const help2Ref: Ref<HTMLElement | null> = ref(null);

const showHelp1 = ref(false);
const showHelp2 = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(IconButton, {
      onClick: open,
      "background-color": "#5E35B1",
      color: "white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, { icon: "dna" })
      ]),
      _: 1
    }),
    _createVNode(Dialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDialog).value = $event)),
      title: "vDNA.title"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("vDNA.description")) + " ", 1),
        _createElementVNode("div", {
          class: "vdna-container",
          ref_key: "containerRef",
          ref: containerRef
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vDNASequences), (line, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_1, _toDisplayString(line.text), 1),
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.annotations, (annotation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "annotation",
                    key: annotation.label,
                    style: _normalizeStyle({ left: annotation.left, width: annotation.width })
                  }, _toDisplayString(_unref(t)(annotation.label)), 5))
                }), 128))
              ])
            ]))
          }), 128))
        ], 512),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "help",
            ref_key: "help1Ref",
            ref: help1Ref,
            onPointerenter: _cache[0] || (_cache[0] = ($event: any) => (showHelp1.value = true)),
            onPointerleave: _cache[1] || (_cache[1] = ($event: any) => (showHelp1.value = false))
          }, _toDisplayString(_unref(t)("vDNA.whatThisMeans")), 545),
          _createElementVNode("div", {
            class: "help",
            ref_key: "help2Ref",
            ref: help2Ref,
            onPointerenter: _cache[2] || (_cache[2] = ($event: any) => (showHelp2.value = true)),
            onPointerleave: _cache[3] || (_cache[3] = ($event: any) => (showHelp2.value = false))
          }, _toDisplayString(_unref(t)("vDNA.howUsed")), 545),
          _createVNode(Tooltip, {
            rect: help1Ref.value?.getBoundingClientRect() ?? null,
            show: showHelp1.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("vDNA.whatThisMeansDescription")), 1)
            ]),
            _: 1
          }, 8, ["rect", "show"]),
          _createVNode(Tooltip, {
            rect: help2Ref.value?.getBoundingClientRect() ?? null,
            show: showHelp2.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("vDNA.howUsedDescription")), 1)
            ]),
            _: 1
          }, 8, ["rect", "show"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})